<template>
    <div class="key-data-sup-change-audit">
        <div class="title">供应商变更审批</div>
        <div class="key-data-sup-change-info">
            <div class="change-type-label">变更类型：</div>
            <div class="title-container">
                <span class="sub-title">变更前</span>
                <i :class="oldContentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapseOld"></i>
            </div>
            <div class="content" v-if="oldContentVisible">
                <el-row>
                    <el-col class="has-bg right-text" :span="3">供应商编码</el-col>
                    <el-col :span="5">{{ formData.supplierCodeOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">供应商名称</el-col>
                    <el-col :span="5">{{ formData.supplierNameCnOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">负责人姓名</el-col>
                    <el-col :span="5">{{ formData.principalNameOld }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text no-wrap" :span="3">统一社会信用代码</el-col>
                    <el-col :span="5">{{ formData.societyCreditCodeOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">法人代表</el-col>
                    <el-col :span="5">{{ formData.corporateNameOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">法人身份证号</el-col>
                    <el-col :span="5">{{ formData.idCardOld }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">付款方式</el-col>
                    <el-col :span="5">{{ formData.paymentTypeOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">付款条件</el-col>
                    <el-col :span="5">{{ formData.paymentTermsOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">分公司</el-col>
                    <el-col :span="5">{{ formData.companyNameOld }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">运输方式</el-col>
                    <el-col :span="5">{{ formData.transportTypeOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">承运商类别</el-col>
                    <el-col :span="5">{{ formData.transTypeOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">服务平台</el-col>
                    <el-col :span="5">{{ formData.siteNameOld }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text no-wrap" :span="3">运力机制合作方式</el-col>
                    <el-col :span="5">{{ formData.cooperationModeOld }}</el-col>
                    <el-col class="has-bg right-text no-wrap" :span="3">合作伙伴起始日期</el-col>
                    <el-col :span="5">{{ formData.cooperationDateOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">合作方式</el-col>
                    <el-col :span="5">{{ formData.corporateTypeOld }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">租赁商类别</el-col>
                    <el-col :span="5">{{ formData.lesseeTypeOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">营业执照注册起始日期</el-col>
                    <el-col :span="5">{{ formData.businessLicenseDateFromOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">营业执照注册终止日期</el-col>
                    <el-col :span="5">{{ formData.businessLicenseDateToOld }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">供应商来源途径</el-col>
                    <el-col :span="5">{{ formData.supplierSourceWayOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">运输业务类型</el-col>
                    <el-col :span="5">{{ formData.transportBusinessTypeOld }}</el-col>
                    <el-col class="has-bg right-text" :span="3">是否直控运力</el-col>
                    <el-col :span="5">{{ formData.isControlTransportOld }}</el-col>
                </el-row>
            </div>
        </div>
        <div class="key-data-sup-change-info">
            <div class="title-container">
                <span class="sub-title">变更后</span>
                <i :class="newContentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapseNew"></i>
            </div>
            <div class="content" v-if="newContentVisible">
                <el-row>
                    <el-col class="has-bg right-text" :span="3">供应商编码</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('supplierCodeNew', 'supplierCodeOld')}">{{ formData.supplierCodeNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">供应商名称</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('supplierNameCnNew', 'supplierNameCnOld')}">{{ formData.supplierNameCnNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">负责人姓名</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('principalNameNew', 'principalNameOld')}">{{ formData.principalNameNew }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text no-wrap" :span="3">统一社会信用代码</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('societyCreditCodeNew', 'societyCreditCodeOld')}">{{ formData.societyCreditCodeNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">法人代表</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('corporateNameNew', 'corporateNameOld')}">{{ formData.corporateNameNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">法人身份证号</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('idCardNew', 'idCardOld')}">{{ formData.idCardNew }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">付款方式</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('paymentTypeNew', 'paymentTypeOld')}">{{ formData.paymentTypeNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">付款条件</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('paymentTermsNew', 'paymentTermsOld')}">{{ formData.paymentTermsNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">分公司</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('companyNameNew', 'companyNameOld')}">{{ formData.companyNameNew }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">运输方式</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('transportTypeNew', 'transportTypeOld')}">{{ formData.transportTypeNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">承运商类别</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('transTypeNew', 'transTypeOld')}">{{ formData.transTypeNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">服务平台</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('siteNameNew', 'siteNameOld')}">{{ formData.siteNameNew }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text no-wrap" :span="3">运力机制合作方式</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('cooperationModeNew', 'cooperationModeOld')}">{{ formData.cooperationModeNew }}</el-col>
                    <el-col class="has-bg right-text no-wrap" :span="3">合作伙伴起始日期</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('cooperationDateNew', 'cooperationDateOld')}">{{ formData.cooperationDateNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">合作方式</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('corporateTypeNew', 'corporateTypeOld')}">{{ formData.corporateTypeNew }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">租赁商类别</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('lesseeTypeNew', 'lesseeTypeOld')}">{{ formData.lesseeTypeNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">营业执照注册起始日期</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('businessLicenseDateFromNew', 'businessLicenseDateFromOld')}">{{ formData.businessLicenseDateFromNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">营业执照注册终止日期</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('businessLicenseDateToNew', 'businessLicenseDateToOld')}">{{ formData.businessLicenseDateToNew }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">供应商来源途径</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('supplierSourceWayNew', 'supplierSourceWayOld')}">{{ formData.supplierSourceWayNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">运输业务类型</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('transportBusinessTypeNew', 'transportBusinessTypeOld')}">{{ formData.transportBusinessTypeNew }}</el-col>
                    <el-col class="has-bg right-text" :span="3">是否直控运力</el-col>
                    <el-col :span="5" :class="{'high-light': isHighlight('isControlTransportNew', 'isControlTransportOld')}">{{ formData.isControlTransportNew }}</el-col>
                </el-row>
            </div>
        </div>
        <RiskControlInfo v-if="supplierCode" :supplierParams="{supplierCode: supplierCode}" />
        <ClientInfo v-if="supplierCode" :supplierCode="supplierCode"/>
        <!-- 如果承运商类型有变化,则显示常跑线路表格 -->
        <RegularLineTable title="常跑线路" :supplierCode="supplierCode" :auditId="auditId" v-if="isTransTypeChange && supplierCode"/>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import { dictWithUrl } from '@/components/lots/api'
import { getSupplierChangeInfo } from '../../../../../../api/keyDataDetail.js'
import RegularLineTable from './RegularLineTable.vue'
import ClientInfo from './ClientInfo.vue'
import RiskControlInfo from './RiskControlInfo.vue';

export default {
    components: {RegularLineTable, ClientInfo, RiskControlInfo},
    props: {
        auditId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            oldContentVisible: true,
            newContentVisible: true,
            dictData: {},
            formData: {
                supplierCodeOld: '-',
                supplierNameCnOld: '-',
                principalNameOld: '-',
                societyCreditCodeOld: '-',
                corporateNameOld: '-',
                idCardOld: '-',
                paymentTypeOld: '-',
                paymentTermsOld: '-',
                companyNameOld: '-',
                transportTypeOld: '-',
                transTypeOld: '-',
                siteNameOld: '-',
                cooperationModeOld: '-',
                cooperationDateOld: '-',
                corporateTypeOld: '-',
                lesseeTypeOld: '-',
                businessLicenseDateFromOld: '-',
                businessLicenseDateToOld: '-',
                supplierSourceWayOld: '-',
                transportBusinessTypeOld: '-',
                isControlTransportOld: '-',

                supplierCodeNew: '-',
                supplierNameCnNew: '-',
                principalNameNew: '-',
                societyCreditCodeNew: '-',
                corporateNameNew: '-',
                idCardNew: '-',
                paymentTypeNew: '-',
                paymentTermsNew: '-',
                companyNameNew: '-',
                transportTypeNew: '-',
                transTypeNew: '-',
                siteNameNew: '-',
                cooperationModeNew: '-',
                cooperationDateNew: '-',
                corporateTypeNew: '-',
                lesseeTypeNew: '-',
                businessLicenseDateFromNew: '-',
                businessLicenseDateToNew: '-',
                supplierSourceWayNew: '-',
                transportBusinessTypeNew: '-',
                isControlTransportNew: '-',
            },
            lineVisible: true,
            supplierCode: '',
            isTransTypeChange: false,
        };
    },
    methods: {
        isHighlight(newProp, oldProp){
            return this.formData[newProp] !== this.formData[oldProp]
        },
        loadData() {
            getSupplierChangeInfo(this.auditId).then(res => {
                if (res && +res.code === 0) {
                    this.setFormData(res.data)
                }
            }).catch(err => {})
        },
        setFormData(data) {
            this.formData.supplierCodeOld = data.supplierCodeOld || '-'
            this.formData.supplierNameCnOld = data.supplierNameCnOld || '-'
            this.formData.principalNameOld = data.principalNameOld || '-'
            this.formData.societyCreditCodeOld = data.societyCreditCodeOld || '-'
            this.formData.corporateNameOld = data.corporateNameOld || '-'
            this.formData.idCardOld = data.idCardOld || '-'
            this.formData.paymentTypeOld = this.dictData.SYS_PAYMENT_TYPE[data.paymentTypeOld] || '-'
            this.formData.paymentTermsOld = this.dictData.BID_PAYMENT_TERMS[data.paymentTermsOld] || '-'
            this.formData.companyNameOld = data.companyNameOld || '-'
            this.formData.transportTypeOld = this.dictData.SRM_TRANSPORT_TYPE[data.transportTypeOld] || '-'
            this.formData.transTypeOld = this.dictData.SRM_SHIPPER_TYPE[data.transTypeOld] || '-'
            this.formData.siteNameOld = data.siteNameOld || '-'
            this.formData.cooperationModeOld = this.dictData.SRM_COOPERATION_MODE[data.cooperationModeOld] || '-'
            this.formData.cooperationDateOld = this.timeformat(data.cooperationDateOld)
            this.formData.corporateTypeOld = this.dictData.SU_CORPORATE_TYPE[data.corporateTypeOld] || '-'
            this.formData.lesseeTypeOld = this.dictData.SU_LEASE_TYPE[data.lesseeTypeOld] || '-'
            this.formData.businessLicenseDateFromOld = data.businessLicenseDateFromOld || '-'
            this.formData.businessLicenseDateToOld = data.businessLicenseDateToOld || '-'
            this.formData.supplierSourceWayOld = this.dictData.SUPPLIER_SOURCE_ROUTE[data.supplierSourceWayOld] || '-'
            this.formData.transportBusinessTypeOld = data.transportBusinessTypeOld ?
                data.transportBusinessTypeOld.split(',').map(item => this.dictData.SRM_TRANSPORT_BUSINESS_TYPE[item]).join(',') : '-'
            this.formData.isControlTransportOld = this.dictData.SYS_SUPPLIER_YES_NO[data.isControlTransportOld] || '-'

            this.formData.supplierCodeNew = data.supplierCodeNew || '-'
            this.formData.supplierNameCnNew = data.supplierNameCnNew || '-'
            this.formData.principalNameNew = data.principalNameNew || '-'
            this.formData.societyCreditCodeNew = data.societyCreditCodeNew || '-'
            this.formData.corporateNameNew = data.corporateNameNew || '-'
            this.formData.idCardNew = data.idCardNew || '-'
            this.formData.paymentTypeNew = this.dictData.SYS_PAYMENT_TYPE[data.paymentTypeNew] || '-'
            this.formData.paymentTermsNew = this.dictData.BID_PAYMENT_TERMS[data.paymentTermsNew] || '-'
            this.formData.companyNameNew = data.companyNameNew || '-'
            this.formData.transportTypeNew = this.dictData.SRM_TRANSPORT_TYPE[data.transportTypeNew] || '-'
            this.formData.transTypeNew = this.dictData.SRM_SHIPPER_TYPE[data.transTypeNew] || '-'
            this.formData.siteNameNew = data.siteNameNew || '-'
            this.formData.cooperationModeNew = this.dictData.SRM_COOPERATION_MODE[data.cooperationModeNew] || '-'
            this.formData.cooperationDateNew = this.timeformat(data.cooperationDateNew)
            this.formData.corporateTypeNew = this.dictData.SU_CORPORATE_TYPE[data.corporateTypeNew] || '-'
            this.formData.lesseeTypeNew = this.dictData.SU_LEASE_TYPE[data.lesseeTypeNew] || '-'
            this.formData.businessLicenseDateFromNew = data.businessLicenseDateFromNew || '-'
            this.formData.businessLicenseDateToNew = data.businessLicenseDateToNew || '-'
            this.formData.supplierSourceWayNew = this.dictData.SUPPLIER_SOURCE_ROUTE[data.supplierSourceWayNew] || '-'
            this.formData.transportBusinessTypeNew = data.transportBusinessTypeNew ?
                data.transportBusinessTypeNew.split(',').map(item => this.dictData.SRM_TRANSPORT_BUSINESS_TYPE[item]).join(',') : '-'
            this.formData.isControlTransportNew = this.dictData.SYS_SUPPLIER_YES_NO[data.isControlTransportNew] || '-'
            //承运商类别变更
            this.isTransTypeChange = data.changeType === '3'
            this.supplierCode = data.supplierCodeNew
        },
        timeformat(time) {
            return time ? dayjs(time).format('YYYY-MM-DD') : '-'
        },
        handleCollapseOld() {
            this.oldContentVisible = !this.oldContentVisible
        },
        handleCollapseNew() {
            this.newContentVisible = !this.newContentVisible
        },
    },
    mounted() {
        dictWithUrl(
            'SYS_PAYMENT_TYPE,BID_PAYMENT_TERMS,SRM_TRANSPORT_TYPE,SRM_SHIPPER_TYPE,SRM_COOPERATION_MODE,' +
            'SU_CORPORATE_TYPE,SU_LEASE_TYPE,SUPPLIER_SOURCE_ROUTE,SRM_TRANSPORT_BUSINESS_TYPE,SYS_SUPPLIER_YES_NO'
        ).then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                this.loadData()
            }
        }).catch(err => {})
    },
};
</script>
<style lang="less" scoped>
.key-data-sup-change-audit {
    color: #000;

    .title {
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: bold;
    }
}

.key-data-sup-change-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .change-type-label {
        margin-bottom: 10px;
        font-weight: bold;
    }

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }

    .el-row {
        display: flex;
        width: 100%;
    }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
    }

    .wrap-label-row .el-col {
        min-height: 50px;
    }

    .no-wrap {
        white-space: nowrap;
    }
    .high-light{
        color: red;
        font-weight: bold;
    }
}
</style>
